// extracted by mini-css-extract-plugin
module.exports = {"slider":"slider_slider__r2c5F"};